import { render, staticRenderFns } from "./page-faqs.vue?vue&type=template&id=f1bf4bea&"
import script from "./page-faqs.vue?vue&type=script&lang=js&"
export * from "./page-faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports